import {Component, Input, OnInit} from '@angular/core';
import {InputTextModule} from "primeng/inputtext";
import {ConfirmationService, MessageService} from "primeng/api";
import {Table, TableModule} from "primeng/table";
import {Button, ButtonDirective} from "primeng/button";
import {CardModule} from "primeng/card";
import {NgIf, NgTemplateOutlet} from "@angular/common";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {RouterLinkActive} from "@angular/router";
import {ToastModule} from "primeng/toast";
import {BadgeModule} from "primeng/badge";
import {ConfirmPopupModule} from "primeng/confirmpopup";
import {InputNumberModule} from "primeng/inputnumber";
import {MenuModule} from "primeng/menu";
import {TagModule} from "primeng/tag";
import {ToolbarModule} from "primeng/toolbar";
import {TooltipModule} from "primeng/tooltip";
import {
    UsuarioDialogComponent
} from "../../../users/mnto-usuarios/components/usuarios/usuario-dialog/usuario-dialog.component";
import {SharedModule} from "../../shared.module";
import {DialogModule} from "primeng/dialog";
import {DropdownModule} from "primeng/dropdown";
import {Ripple} from "primeng/ripple";
import {KeyFilterModule} from "primeng/keyfilter";
import {DashboardComponent} from "../../../officials/autorizaciones/components/dashboard/dashboard.component";
import {DialogService} from "primeng/dynamicdialog";
import {PersonasService} from "../../services/personas-service";
import {AutorizacionesService} from "../../../officials/autorizaciones/services/autorizaciones.service";
import {LoginServices} from "../../../auth/login/services/login.service";

import {Contacto,TipoAutorizaciones} from "../../interfaces/shared-interface";

@Component({
  selector: 'app-personas-table',
  standalone: true,
    imports: [
        ButtonDirective,
        CardModule,
        NgIf,
        ProgressSpinnerModule,
        RouterLinkActive,
        ToastModule,
        BadgeModule,
        Button,
        ConfirmPopupModule,
        InputNumberModule,
        InputTextModule,
        MenuModule,
        TableModule,
        TagModule,
        ToolbarModule,
        TooltipModule,
        UsuarioDialogComponent,
        SharedModule,
        DialogModule,
        DropdownModule,
        Ripple,
        NgTemplateOutlet,
        KeyFilterModule,
        DashboardComponent
    ],
    providers: [ConfirmationService, DialogService, MessageService],
  templateUrl: './personas-table.component.html',
  styleUrl: './personas-table.component.scss'
})
export class PersonasTableComponent implements OnInit {
    @Input() textCurrentPageTable: string = "";
    @Input() textCaption: string = "";
    @Input() filterByTypes: number [] = [];
    _showLoader: boolean = true;
    tipos:number=0;
    cols: any[] = [];
    protected readonly TipoAutorizaciones = TipoAutorizaciones;
    constructor(public personasService: PersonasService, protected autorizacionesService: AutorizacionesService,
                protected loginServices: LoginServices) {
    }

    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
        this.getConsultaAutorizaciones(this.filterByTypes);
    }

    getConsultaAutorizaciones(tipos:number[]) {
        if(tipos.length==0){
            console.error("tipos no debe ser nulo o cero")
            return;
        }
        this.autorizacionesService.tipoAutorizacion.set(tipos);
        this.autorizacionesService.consultaAutorizaciones(this.loginServices.session()?.perfil?.uniqueId!,tipos)
            .subscribe(resp => {
                if (resp) {
                    this.autorizacionesService._autorizacionesPersona.set(resp!.body!);
                    this._showLoader=false;
                }
            });
    }

    autorizacionFilter(table: Table, event: Event) {
        table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
    }

    tagStyle(estado: number) {
        switch (estado) {
            case 1:
                return {background: '#28a745'};
            case 0:
                return {background: '#FF0000FF'};
            default:
                return {background: '#6c757d'};
        }
    }

    findContactoByTipo(contactos: Contacto[], tipo: string): Contacto | undefined {
        return contactos.find(contacto => contacto.tipo === tipo);
    }

    ngOnDestroy(): void {
        this.autorizacionesService._autorizacionesPersona.set([])
    }
}
